import type { I18n } from "@lingui/core";
import type { billing_DunningCockpitItemResponse } from "@/api/models/billing_DunningCockpitItemResponse";
import { debtorLabel } from "@/components/billing/debtorDisplay";

/**
 * Returns the canonical "Family Schulte (0420 Mia Schulte, ...)" / "Familie
 * Schulte (...)" label for a dunning cockpit row, sourced from the embedded
 * `debtor_account` block. Falls back to the stored `household_name` when the
 * backend omitted the enriched DTO (e.g. on a freshly-built manual-action
 * response that didn't run the batched lookup).
 *
 * Single source of truth: `debtorLabel` in `components/billing/debtorDisplay`,
 * shared with the Reconciliation > Debtor Accounts page and the Workflow Inbox
 * dunning rows.
 */
export function formatHouseholdLabel(
  item: billing_DunningCockpitItemResponse,
  i18n: I18n,
): string {
  if (item.debtor_account) {
    const label = debtorLabel(item.debtor_account, i18n);
    if (label) return label;
  }
  return item.household_name ?? "";
}
